import { render } from "./SalesFlatRates.vue?vue&type=template&id=c9f64fb0"
import script from "./SalesFlatRates.vue?vue&type=script&lang=js"
export * from "./SalesFlatRates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__